import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';

import { AccountMenuComponent } from '@components2/shell/sidebar/account-menu/account-menu.component';
import { NavigationItem } from '@interfaces/app/content.interfaces';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { PopoverModule } from 'primeng/popover';
import { Ripple } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClass } from 'primeng/styleclass';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

import { DarkModeService } from '@services/dark-mode.service';

import { DarkModeToggleComponent } from '../dark-mode-toggle/dark-mode-toggle.component';

export interface GroupedNavigationItem extends NavigationItem {
  children: NavigationItem[] | undefined | null;
}
@Component({
  selector: 'bk-sidebar-menu',
  imports: [
    DrawerModule,
    ButtonModule,
    Ripple,
    AvatarModule,
    StyleClass,
    RouterModule,
    CommonModule,
    ToggleSwitchModule,
    FormsModule,
    SkeletonModule,
    AccountMenuComponent,
    PopoverModule,
    DarkModeToggleComponent,
  ],
  templateUrl: './sidebar-menu.component.html',
  styleUrl: './sidebar-menu.component.scss',
})
export class SidebarMenuComponent {
  title = input<string>();
  navItems = input<NavigationItem[]>();
  closeMenu = output();
  darkModeService = inject(DarkModeService);
  router = inject(Router);

  showAccountMenu = signal(false);

  groupedNavItems = computed<GroupedNavigationItem[]>(() => {
    const navItems = this.navItems();
    if (!navItems) return [];

    const groupedNavItems: GroupedNavigationItem[] = navItems.reduce((acc, navItem) => {
      if (!navItem.parentId) {
        return [...acc, { ...navItem, children: [] }];
      }
      return acc;
    }, [] as GroupedNavigationItem[]);

    const groupedWithChildren = groupedNavItems.map((item) => {
      const parentId = item.id;
      const children = navItems.filter((navItem) => navItem.parentId === parentId);
      return { ...item, children, expanded: item.expanded ? item.expanded : false };
    });

    return groupedWithChildren;
  });

  menuItemClicked() {
    if (window.innerWidth < 1024) {
      this.closeMenu.emit();
    }
  }

  toggleDarkMode() {
    this.darkModeService.toggleDarkMode();
  }
}
